export const LANGUAGE_MAP: Record<string, string> = {
  ru: 'ru', // Russian
  be: 'ru', // Belarusian → Russian
  kk: 'ru', // Kazakh → Russian
  uk: 'ru', // Ukrainian → Russian
  en: 'en', // English
  ar: 'ar', // Arabic
  '*': 'ru', // Default fallback to Russian
};

export const detectUserLanguage = (language_code?: string): string => {
  const userLang = language_code || '*';

  // Handle Arabic variants (ar, ar-SA, ar-EG, etc)
  if (userLang.startsWith('ar')) {
    return 'ar';
  }

  // Handle English variants (en, en-US, en-GB, etc)
  if (userLang.startsWith('en')) {
    return 'en';
  }

  // Check specific language mappings
  if (userLang in LANGUAGE_MAP) {
    return LANGUAGE_MAP[userLang];
  }

  // Default to Russian for unknown languages
  return 'ru';
};
